const addmobileLabel = {
  id: 'schedulePMFlowDialog.addTurn',
}

const textIds = {
  addmobileLabel,
}

export default textIds
